import React, {FunctionComponent, useContext, useState} from 'react'
import {Grid, Header, Icon, Label, Loader, Segment} from "semantic-ui-react";
import moment from "moment";
import {ClientGoalStatus, IClientGoal} from "../../../../app/models/clientGoals";
import DateTimePickerWithShortcuts from "../../../commom/date/DateTimePickerWithShortcuts";
import ShowMoreButton from "../../../commom/buttons/ShowMoreButton";
import {RootStoreContext} from "../../../../app/stores/rootStore";
import {
    dateToLocaleStringOrAccentYesterdayTodayAndTomorrow
} from "../../../../app/common/util/date";

interface OwnProps {
    clientGoal: IClientGoal
}

type Props = OwnProps

const ClientGoalDatesCellPlannedDate: FunctionComponent<Props> = ({clientGoal}) => {
    const rootStore = useContext(RootStoreContext)
    const {updateDate} = rootStore.clientGoalsStore

    const [editMode, setEditMode] = useState(false)
    const [showEditIcon, setShowEditIcon] = useState(false)

    return <>
        {editMode ?
            <Segment.Group compact>
                <Segment attached='bottom' style={{padding: 5}}>

                    <Label
                        basic
                        style={{border: 0}}
                        attached='top right'>
                        <Loader size='mini' inline active={clientGoal.flags?.updating}/>
                        <Icon
                            style={{cursor: 'pointer'}}
                            name='x'
                            circular
                            size='small'
                            onClick={() => setEditMode(false)}
                        />
                    </Label>
                    <DateTimePickerWithShortcuts
                        placeholder='Planirani datum'
                        shortcuts={{
                            today: true,
                            tomorrow: true,
                            nextWeek: true
                        }}
                        vertical
                        disabled={clientGoal.flags?.updating}
                        date={clientGoal.date ? moment(clientGoal.date) : null}
                        onChange={date =>
                            updateDate(clientGoal.id, 'planed', date ? date.format('YYYY-MM-DD') : null)}/>
                </Segment>
            </Segment.Group> :
            <div>
                {clientGoal.date ? <Header
                        size='tiny'
                        color='grey'>
                        <Header.Content>
                            <Header.Subheader
                                onMouseEnter={() => setShowEditIcon(true)}
                                onMouseLeave={() => setShowEditIcon(false)}
                            >
                                Predviđen:
                                {moment(clientGoal.date).isBetween(moment().subtract(2, 'day'), moment().add(2, 'day'), 'day') ?
                                    <Header as='h4' color='blue' content={dateToLocaleStringOrAccentYesterdayTodayAndTomorrow(clientGoal.date)} /> :
                                    <span>{moment(clientGoal.date).format('l')}</span>}{' '}{showEditIcon && <Icon
                                link
                                name='pencil alternate'
                                onClick={() => setEditMode(true)}
                                color='orange'/>}</Header.Subheader>
                            {clientGoal.status === ClientGoalStatus.inProgress && moment(clientGoal.date).isBefore(new Date(), 'day') &&
                            <Header style={{marginTop: 3}} as='h4' color='red'>Istekao
                                pre {moment(new Date()).diff(clientGoal.date, 'days')} dana <Icon
                                    name='info circle'/></Header>}
                        </Header.Content>
                    </Header> :
                    <Grid>
                        <Grid.Column textAlign='center' width={16}>
                            <ShowMoreButton content='Dodaj planirani datum' onClick={() => setEditMode(true)}/>
                        </Grid.Column>
                    </Grid>}
            </div>}
    </>
}

export default ClientGoalDatesCellPlannedDate
